import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import TranslatedCopy from '../../intl/translated-copy';

const getDurationObj = (durationInMinutes) => {
  const duration = Moment.duration(durationInMinutes, 'minutes');
  return {
    numDays: duration.days(),
    numHours: duration.hours(),
    numMinutes: duration.minutes(),
  };
};

const Duration = ({
  className,
  durationInMinutes,
}) => {
  const { numDays, numHours, numMinutes } = getDurationObj(durationInMinutes);

  return (
    <span className={ className }>
      { numDays ? numDays : null }
      { numDays ? <TranslatedCopy copyID='APP_DAYS_SHORT' spaceAfter={ true } /> : null }
      { numHours ? numHours : null }
      { numHours ? <TranslatedCopy copyID='APP_HOURS_SHORT' spaceAfter={ true } /> : null }
      { numMinutes ? numMinutes : null }
      { numMinutes ? <TranslatedCopy copyID='APP_MINUTES_SHORT' /> : null }
    </span>
  );
};

Duration.propTypes = {
  className: PropTypes.string,
  durationInMinutes: PropTypes.number.isRequired,
};

export default Duration;
